{
  "version": 1,
  "asset_id": "07861115-f490-46fa-9b6f-1b8a43885231",
  "project_id": "81e5f51e-81a3-47ad-9e0d-7249ca4c0a70",
  "url": "/__l5e/assets-v1/07861115-f490-46fa-9b6f-1b8a43885231/paypal.svg",
  "r2_key": "a/v1/81e5f51e-81a3-47ad-9e0d-7249ca4c0a70/07861115-f490-46fa-9b6f-1b8a43885231/paypal.svg",
  "original_filename": "paypal.svg",
  "size": 5588,
  "content_type": "image/svg+xml",
  "created_at": "2026-08-30T15:11:53Z"
}
